import { mapGetters } from 'vuex'

export default {
  name: 'Merchants',
  props: [],
  computed: {
    ...mapGetters(['merchants'])
  },
  data () {
    return {
      selectedCategory: '',
      page: 1
    }
  },
  mounted () {
    this.$store.dispatch("merchantsDashboard").then((result) => {
      this.selectedCategory = result.categories[0]
    })
  },
  methods: {
    selectCategory (category) {
      this.page = 1
      this.selectedCategory = this.merchants[category]
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/EplNewMerchants/component.js